// React app entry point
import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App.tsx";
import "./index.css";
import GlobalErrorBoundary from "./components/errors/GlobalErrorBoundary";
import { connectivityService } from "./lib/connectivityService";
import { maybeInitSentry } from "./lib/cookieConsent";
import { registerPwaUpdates } from "./lib/pwa/registerPwaUpdates";

// Start the central connectivity service (singleton, runs for app lifetime)
connectivityService.start();

// Initialise Sentry only when the user has previously given analytics consent.
// If no consent exists yet the CookieConsentBanner will handle first-time consent
// and call initSentryIfConsented() at runtime.
maybeInitSentry();
registerPwaUpdates();
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);

// Remove the initial HTML loader after React takes over
// This ensures the loader doesn't persist on pages like /auth
requestAnimationFrame(() => {
  document.getElementById("initial-loader")?.remove();
});
